const readMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
      readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
        label
        values {
          values {value}
        }
        avg
        total
        perMin
      }`
};

const readMetricsValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
      readMetricsValue: readMobileMetricsValue(condition: $condition, duration: $duration)`
};

const sortMetrics = {
  variable: ['$condition: TopNCondition!, $duration: Duration!'],
  fragment: `
      sortMetrics: sortMetrics(condition: $condition, duration: $duration) {
        name
        id
        value
        refId
      }`
};

const readLabeledMetricsValues = {
  variable: [
    '$condition: MetricsCondition!, $labels: [String!]!, $duration: Duration!'
  ],
  fragment: `
      readLabeledMetricsValues: readLabeledMetricsValues(
        condition: $condition,
        labels: $labels,
        duration: $duration) {
        label
        values {
          values {value}
        }
      }`
};

const readHeatMap = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
      readHeatMap: readHeatMap(condition: $condition, duration: $duration) {
        values {
          id
          values
        }
        buckets {
          min
          max
        }
      }`
};

const readSampledRecords = {
  variable: ['$condition: TopNCondition!, $duration: Duration!'],
  fragment: `
      readSampledRecords: readSampledRecords(condition: $condition, duration: $duration) {
        name
        value
        refId
      }`
};
const readMetricsTotalValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
    readMetricsTotalValue: readMetricsTotalValue(condition: $condition, duration: $duration)`
};

const readCustomMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
  readCustomMetricsValues: readCustomMetricsValues(condition: $condition, duration: $duration) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }`
};
export default {
  readSampledRecords,
  readHeatMap,
  readLabeledMetricsValues,
  sortMetrics,
  readMetricsValue,
  readMetricsValues,
  readMetricsTotalValue,
  readCustomMetricsValues
};
